// Modal "Salvar filtro" (mockup Aeros): nome, resumo dos filtros ativos em
// chips e toggle de envio semanal por e-mail. Persistência: POST
// /report-filters (backend do relatório).
import React, { useState } from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import ScheduleSendIcon from "@material-ui/icons/Send";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import useAerosSettingsStyles from "../../components/Settings/aerosSettingsStyles";
import { AEROS, stateText } from "../../styles/aerosTokens";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  return {
    paper: { width: 440, maxWidth: "calc(100vw - 32px)", margin: 16 },
    body: { padding: "18px 24px", display: "flex", flexDirection: "column", gap: 12 },
    chips: { display: "flex", gap: 6, flexWrap: "wrap" },
    chip: { fontSize: 11, fontWeight: 600, borderRadius: 6, padding: "3px 9px", color: theme.palette.text.secondary, backgroundColor: isLight ? theme.palette.action.hover : "rgba(255,255,255,0.06)" },
    chipInfo: { color: stateText(theme, AEROS.cyan, "info"), backgroundColor: alpha(AEROS.cyan, 0.1) },
    chipOk: { color: stateText(theme, AEROS.success, "success"), backgroundColor: alpha(AEROS.success, 0.1) },
    row: { display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", backgroundColor: theme.palette.aeros.surface, border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.07)"}`, borderRadius: 12, "& .MuiSvgIcon-root": { fontSize: 17, color: stateText(theme, "#C08BFF", "purple") } },
    rowTitle: { fontSize: 12.5, fontWeight: 600, color: theme.palette.text.primary },
    rowSub: { fontSize: 11, color: theme.palette.text.secondary },
  };
});

const t = (k, o) => i18n.t(`aeros.reports.${k}`, o);

export default function SaveFilterModal({ open, onClose, onSave, chips, email, loading }) {
  const classes = useStyles();
  const m = useAerosModalStyles();
  const aeros = useAerosSettingsStyles();
  const [name, setName] = useState("");
  const [weekly, setWeekly] = useState(false);

  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth={false} classes={{ paper: classes.paper }}>
      <form className={m.form} onSubmit={(e) => { e.preventDefault(); if (name.trim()) onSave({ name: name.trim(), emailWeekly: weekly }); }}>
        <div className={m.header}>
          <div style={{ flex: 1 }}>
            <div className={m.title}>{t("save.title")}</div>
            <div className={m.subtitle}>{t("save.subtitle")}</div>
          </div>
          <IconButton className={m.closeButton} onClick={onClose} aria-label={i18n.t("aeros.header.close")}><CloseIcon /></IconButton>
        </div>
        <div className={classes.body}>
          <div>
            <div className={m.fieldLabel}>{t("save.name")}</div>
            <TextField className={m.input} variant="outlined" size="small" value={name} onChange={(e) => setName(e.target.value)} placeholder={t("save.namePlaceholder")} autoFocus fullWidth inputProps={{ "aria-label": t("save.nameAria") }} />
          </div>
          <div className={classes.chips}>
            {chips.map((c) => (
              <span key={c.label} className={`${classes.chip} ${c.tone === "info" ? classes.chipInfo : c.tone === "success" ? classes.chipOk : ""}`}>{c.label}</span>
            ))}
          </div>
          <div className={classes.row}>
            <ScheduleSendIcon />
            <div style={{ flex: 1 }}>
              <div className={classes.rowTitle}>{t("save.weekly")}</div>
              <div className={classes.rowSub}>{email || t("save.noEmail")}</div>
            </div>
            <Switch className={aeros.toggleSwitchSmall} checked={weekly} disabled={!email} onChange={(e) => setWeekly(e.target.checked)} inputProps={{ "aria-label": t("save.weekly") }} />
          </div>
        </div>
        <div className={m.footer}>
          <div className={m.footerActions}>
            <Button className={m.cancelButton} onClick={onClose}>{t("cancel")}</Button>
            <Button type="submit" className={m.submitButton} disabled={loading || !name.trim()} startIcon={loading ? <CircularProgress size={14} /> : null}>{t("save.button")}</Button>
          </div>
        </div>
      </form>
    </Dialog>
  );
}
